import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import { SAVE_COUPON, Coupon } from '@bowtie-web/common';

type SaveCouponResponse = {
  saveCoupon: Coupon[];
};

const useSaveCoupon = (options?: MutationHookOptions<SaveCouponResponse>) => {
  const [saveCouponMutation, result] = useMutation<SaveCouponResponse>(
    SAVE_COUPON,
    options,
  );

  const saveCoupon = async (couponCode: string, mutationOptions = {}) => {
    const { data } = await saveCouponMutation({
      variables: {
        input: {
          coupon_code: couponCode.toUpperCase(),
        },
      },
      ...mutationOptions,
    });
    return data?.saveCoupon || [];
  };

  return [saveCoupon, result] as const;
};

export default useSaveCoupon;
